import { createReducer, on } from '@ngrx/store';
import {  AsignaBreadcrumb, AsignaPermisos, EliminaPermisos } from '../actions/permisos.actions';

export interface IModulo {
    id: number,
    objects: any[],
    authorized: boolean,
    type: string,
    caption: string,
    name: string,
    father: any,
    key: string,
    order: number,
    aplicacionId: number,
    children?: IModulo[],
    title: string,
    icon: string,
    link: string,
}

export interface State {
    modulos: IModulo[];
    error: string | null;
    breadcrumb: string | null;
}

export const initialState: State = {
    modulos: null,
    error: null,
    breadcrumb: null,
};

const _permisosReducer = createReducer(
    initialState,
    on(AsignaPermisos, (state, payload) => ({
        ...state,
        error: null,
        modulos: payload.modulos
    })),
    on(AsignaBreadcrumb, (state, payload) => ({
        ...state,
        error: null,
        breadcrumb: payload.breadcrumb
    })),
    on(EliminaPermisos, (state) => (
        initialState
    ))
);

export function permisosReducer(state, action) {
    return _permisosReducer(state, action);
}
